import * as React from "react";
import {FUNDING, PayPalMessages, PayPalScriptProvider} from "@paypal/react-paypal-js";
import {
  getBuyerCountryForMessage,
  getPayPalLocale,
  isPayLaterAllowed
} from "../payments/paypal/helpers/paypalHelperFunctions";
import {createRoot} from "react-dom/client";
import {PayPalScriptOptions} from "@paypal/paypal-js";

type PlacementType = "category" | "product" | "cart" | "payment" | undefined;

export const clientId = __DEVELOPMENT__
  ? "AQyitgyuMfFcy_-n_KyqJUJMcbCCBg05q4rLF_qHB5u8aYhHcomFJZzIyiYIdfsa9VK3Buvig1mXeVjB"
  : "AdjsQ2iJzhoxhSDBQTT7zmPioworpew6yJylFCMNRe2m4xg_mUqDDLmI05Qq_xXaStZ6vXhfIBYl8bqe";

class PayPalPayLaterMessagePortal {
  public static run() {
    const paypalPaylaterMessageDiv = document.body.querySelector<HTMLDivElement>(".paypal-pay-later-info");
    const priceValue = document.body.querySelector<HTMLSpanElement>("span.price-value[data-price-value]")?.dataset
      .priceValue;

    if (!paypalPaylaterMessageDiv || !priceValue || !isPayLaterAllowed(null)) {
      return;
    }

    const root = createRoot(paypalPaylaterMessageDiv);
    root.render(<PayPalPayLaterMessage container={paypalPaylaterMessageDiv} priceValue={priceValue} />);
  }
}

export default PayPalPayLaterMessagePortal;

const PayPalPayLaterMessage: React.FC<{container: HTMLDivElement; priceValue: string}> = ({container, priceValue}) => {
  const locale = getPayPalLocale();
  const buyerCountry = locale?.split("_")[1];

  const options: PayPalScriptOptions = {
    clientId,
    components: "messages",
    enableFunding: FUNDING.PAYLATER,
    locale,
    buyerCountry,
    commit: false,
    currency: window.c_ActiveCurrency,
    dataPageType: "product-details",
    dataNamespace: "paylatermessage",
  };

  return (
    <PayPalScriptProvider options={options}>
      <PayPalMessages
        style={{layout: "text"}}
        amount={priceValue}
        currency={window.c_ActiveCurrency as "EUR" | "GBP" | "USD"}
        placement={"product" as PlacementType}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        buyerCountry={getBuyerCountryForMessage()}
        onRender={
          (/* dataParam */) => {
            container.style.opacity = "1";
          }
        }
      />
    </PayPalScriptProvider>
  );
};
